module.exports = __webpack_public_path__ + "static/font-6c7e01564dde39fa3cb3e74cdf1c6db8.woff2";